import { useTranslation } from 'react-i18next'

import { QA_NAME_DELETE_ITEM } from '../../../../constants/qa'
import { REQUEST_STATUS } from '../../../../constants/request'
import { stopPropagation } from '../../../../utils/events'
import { Avatar, AVATAR_HEIGHT_32 } from '../../../Avatar'
import Button, { BUTTON_HEIGHT_24 } from '../../../Button'
import { EntityArchivedIcon, EntityStatus } from '../../../Entity'
import { FloatingTooltip } from '../../../Floating'
import { MultiValuedListMoreItem } from '../../../MultiValuedList'
import { STATUS_SIZE_20 } from '../../../Status'
import { getRequestTitle } from '../../Request.utils'
import { getTooltipContent } from '../RequestMultiValuedList.utils'

import * as styles from './RequestMultiValuedListMoreItem.module.css'

import DeleteIcon from '../../../../icons/delete.svg'
import ServiceRequestIcon from '../../../../icons/service-request.svg'

function RequestMultiValuedListMoreItem({
  archived,
  id,
  removeTooltipKey,
  request_no,
  status,
  title,
  onClick,
  onMouseDown,
  onRemove,
  ...itemProps
}) {
  const { t } = useTranslation()

  const request = { id, request_no, status, title }

  function handleClick(event) {
    onClick?.(id, event)
  }

  function handleMouseDown(event) {
    onMouseDown?.(id, event)
  }

  function handleRemove(event) {
    stopPropagation(event)

    onRemove(id, event)
  }

  return (
    <MultiValuedListMoreItem
      {...itemProps}
      className={styles.moreItem}
      onClick={handleClick}
      onMouseDown={handleMouseDown}
    >
      <div className={styles.item}>
        <Avatar Icon={ServiceRequestIcon} size={AVATAR_HEIGHT_32} />
        <div className={styles.info}>
          <FloatingTooltip
            content={getTooltipContent({
              archived,
              requestNumber: request_no,
              status,
              t,
              title,
            })}
          >
            <span className={styles.text}>
              {getRequestTitle({ requestNumber: request_no, title })}
            </span>
          </FloatingTooltip>
          <EntityStatus
            height={STATUS_SIZE_20}
            id={request.status}
            statuses={REQUEST_STATUS}
          />
        </div>
        {archived ? (
          <EntityArchivedIcon
            containerClassName={styles.archivedIconContainer}
          />
        ) : null}
        {onRemove ? (
          <Button.Icon
            isGrey
            Icon={DeleteIcon}
            className={styles.removeButton}
            height={BUTTON_HEIGHT_24}
            qaName={QA_NAME_DELETE_ITEM}
            tooltip={removeTooltipKey ? t(removeTooltipKey) : null}
            onClick={handleRemove}
            onMouseDown={stopPropagation}
          />
        ) : null}
      </div>
    </MultiValuedListMoreItem>
  )
}

export default RequestMultiValuedListMoreItem
